import { Link, useLocation } from "react-router-dom";
import { Home, UtensilsCrossed, Info, Shield, BookText } from "lucide-react";
import { useTranslation } from "react-i18next";
import { cn } from "@/utils";
import { useIsStandalone } from "@/hooks";
import { motion } from "framer-motion";

export const MobileBottomBar = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const isStandalone = useIsStandalone();

  // In standalone (APK) mode, only show menu
  const navItems = isStandalone
    ? [
        {
          href: "/full-menu",
          icon: UtensilsCrossed,
          label: t("NAV.MENU", "القائمة"),
        },
      ]
    : [
        { href: "/", icon: Home, label: t("NAV.HOME", "الرئيسية") },
        {
          href: "/full-menu",
          icon: UtensilsCrossed,
          label: t("NAV.MENU", "القائمة"),
        },
        { href: "/about", icon: Info, label: t("NAV.ABOUT", "عنّا") },
        {
          href: "/profile",
          icon: BookText,
          label: t("PROFILE.NAV", "الملف"),
        },
        {
          href: "/privacy-policy",
          icon: Shield,
          label: t("PRIVACY.NAV_TEXT", "الخصوصية"),
        },
      ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-40 bg-bodyBg/95 backdrop-blur-md border-t border-border-2/60 md:hidden pb-safe">
      <div className="flex items-center justify-around h-14 min-[375px]:h-16">
        {navItems.map((item) => {
          const isActive =
            location.pathname === item.href ||
            (item.href !== "/" && location.pathname.startsWith(item.href));
          return (
            <Link
              key={item.href}
              to={item.href}
              className={cn(
                "flex flex-col items-center justify-center gap-0.5 min-w-0 flex-1 h-full relative transition-colors px-1",
                isActive
                  ? "text-secondary"
                  : "text-thirdText hover:text-primary",
              )}
            >
              <item.icon
                className={cn(
                  "size-[18px] min-[375px]:size-5 transition-transform duration-200",
                  isActive && "scale-105",
                )}
              />
              <span className="text-[9px] min-[375px]:text-[10px] font-bold tracking-wide whitespace-nowrap truncate max-w-full">
                {item.label}
              </span>
              {isActive && (
                <motion.div
                  layoutId="activeBottomTab"
                  className="absolute bottom-1 size-1 rounded-full bg-secondary"
                  transition={{ type: "spring", stiffness: 380, damping: 30 }}
                />
              )}
            </Link>
          );
        })}
      </div>
    </nav>
  );
};
